import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiActivity, FiFlaskConical, FiAward, FiCpu } = FiIcons;

const ApplicationAreas = () => {
  const applicationCards = [
    {
      title: "Pharma & Forschung",
      icon: FiFlaskConical,
      points: [
        "Reproduzierbare Wirkstoffpflanzen-Biomasse für klinische Studien",
        "CITES-konforme Kultivierung geschützter Arten",
        "Lückenlose Chargendokumentation & Audit Trail"
      ]
    },
    {
      title: "Gourmet & Spitzenküche",
      icon: FiAward,
      points: [
        "Ganzjährige Verfügbarkeit von echtem Wasabi und Premium-Safran",
        "Pestizidfreie Laborqualität für Sterne-Gastronomie",
        "Individuelle Klimaprofile je Kulturart"
      ]
    },
    {
      title: "Industrielle Eigenversorgung",
      icon: FiCpu,
      points: [
        "Dezentrale, standortunabhängige Produktion",
        "Krisenresistente Rohstoffversorgung ohne Importabhängigkeit",
        "Skalierbar durch modularen Flottenbetrieb"
      ]
    }
  ];

  return (
    <div className="pt-24 bg-white min-h-screen">
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center max-w-3xl mx-auto mb-20">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <span className="text-emerald-600 font-bold uppercase tracking-widest text-sm mb-2 block">
                Einsatzbereiche
              </span>
              <h1 className="text-4xl md:text-5xl font-bold text-stone-900 mb-6">
                Skalierbare Lösungen für <br />
                <span className="text-emerald-600 italic">komplexe Biosysteme</span>
              </h1>
              <p className="text-lg text-stone-600">
                Die CoreUnit-Infrastruktur bietet eine neutrale, hochpräzise Plattform für verschiedenste Sektoren. Wir liefern die Technologie – Sie steuern die Produktion.
              </p>
            </motion.div>
          </div>

          {/* Feature Grid */}
          <div className="grid lg:grid-cols-3 gap-8">
            {applicationCards.map((card, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.15, duration: 0.5 }}
                className="bg-stone-50 p-10 rounded-[40px] border border-stone-100 shadow-sm hover:shadow-xl hover:bg-white transition-all duration-500 group"
              >
                <div className="w-16 h-16 bg-white text-emerald-600 rounded-2xl flex items-center justify-center mb-10 shadow-sm group-hover:scale-110 group-hover:bg-emerald-600 group-hover:text-white transition-all duration-300">
                  <SafeIcon icon={card.icon} className="text-3xl" />
                </div>
                <h3 className="text-2xl font-bold text-stone-900 mb-8 border-b border-stone-200 pb-4">
                  {card.title}
                </h3>
                <ul className="space-y-6">
                  {card.points.map((point, pIdx) => (
                    <li key={pIdx} className="flex items-start gap-4">
                      <div className="mt-1.5 shrink-0">
                        <div className="w-5 h-5 bg-emerald-100 rounded-full flex items-center justify-center">
                          <SafeIcon icon={FiCheck} className="text-emerald-600 text-[10px] font-bold" />
                        </div>
                      </div>
                      <span className="text-stone-600 leading-snug">{point}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>

          {/* Technical Note */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="mt-24 p-8 bg-stone-900 rounded-[32px] text-center"
          >
            <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiActivity} className="text-emerald-400 text-xl" />
                <span className="text-stone-300 font-medium tracking-wide uppercase text-xs">EU-GMP Grade C Design</span>
              </div>
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiActivity} className="text-emerald-400 text-xl" />
                <span className="text-stone-300 font-medium tracking-wide uppercase text-xs">ISO-7 konforme Luftführung</span>
              </div>
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiActivity} className="text-emerald-400 text-xl" />
                <span className="text-stone-300 font-medium tracking-wide uppercase text-xs">Full API Control</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ApplicationAreas;